export const sampleData: ISampleDataPerFlavour = {
    normal: {
        id: 'normal',
        strings: {
            header: 'Apps',
        },
        colors: {},
        extra: {
            appsDatasetId: 'apps',
        },
    },
};
